(() => {
  if (customElements.get('ssnk-comparison')) return;
  customElements.define('ssnk-comparison', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const input = this.querySelector('[data-comparison-range]');
      if (!input) return;
      const update = () => { const value = Math.min(100, Math.max(0, Number(input.value) || 0)); this.style.setProperty('--position', value + '%'); input.setAttribute('aria-valuetext', value + '%'); };
      input.addEventListener('input', update, { signal: this.controller.signal });
      input.addEventListener('change', update, { signal: this.controller.signal });
      update();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
})();
